import { IonText } from '@ionic/react';
import { FormattedMessage, useIntl } from 'react-intl';

import DateAndTimeRange from '@components/dates/DateAndTimeRange';
import Nbsp from '@components/Nbsp';
import SectionWithBanner from '@components/SectionWithBanner';
import { CareProfileUseCaseEnum, ConsultFragment as Consult } from '@typing/Generated';
import { underEighteenOrGrieving } from '@utils/modelUtils';

type Props = {
  consult: Consult;
  useCase: CareProfileUseCaseEnum | null;
};

const ConsultReportInfo = ({ consult, useCase }: Props) => {
  const intl = useIntl();

  return (
    <SectionWithBanner titleKey="models.consultReport.info.title">
      <p>
        <DateAndTimeRange endTime={consult.endTime} startTime={consult.startTime} />
      </p>
      {consult.consultReport?.duration && (
        <p>
          <IonText>
            <FormattedMessage
              id="models.consultReport.info.duration"
              values={{ duration: consult.consultReport.duration }}
            />
          </IonText>
        </p>
      )}
      <p>
        <IonText>
          <FormattedMessage id="models.consultReport.info.expert" values={{ name: consult.expert.firstName }} />
        </IonText>
      </p>

      {consult?.clientAttendees?.clients && (
        <p>
          <IonText>
            <FormattedMessage id="models.consultReport.info.clientAttendees" />
            {consult.clientAttendees.clients.map((client, index) => (
              <IonText key={client.id}>
                {client.fullName}
                {consult.consultReport && index < consult.clientAttendees.clients.length - 1 && (
                  <>
                    <FormattedMessage id="dictionary.punctuation.comma" />
                    <Nbsp />
                  </>
                )}
              </IonText>
            ))}
            {consult.clientAttendees.other && (
              <>
                {consult.clientAttendees.clients.length > 0 && (
                  <>
                    <FormattedMessage id="dictionary.punctuation.comma" />
                    <Nbsp />
                  </>
                )}
                {consult.clientAttendees.other}
              </>
            )}
          </IonText>
        </p>
      )}
      {consult.consultReport?.stage && !underEighteenOrGrieving({ useCase }) && (
        <p>
          <IonText>
            <FormattedMessage
              id="models.consultReport.info.stage"
              values={{
                stage: intl.formatMessage({ id: `models.journey.stage.${consult.consultReport.stage}` })
              }}
            />
          </IonText>
        </p>
      )}
    </SectionWithBanner>
  );
};

export default ConsultReportInfo;
